import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import {
  HarnessPreferences,
  HarnessPreferencesResponse,
  UpdateHarnessPreferencesRequest,
} from "./types";

// Export types
export * from "./types";

const ENDPOINTS = {
  HARNESS_PREFERENCES: {
    SHOW: "/api/v2/org/:organization_id/user/:user_id/harness-preferences",
    UPDATE: "/api/v2/org/:organization_id/user/:user_id/harness-preferences",
  },
};

export class HarnessPreferencesAPI {
  private client: CohesiveAPIClient;

  constructor(client: CohesiveAPIClient) {
    this.client = client;
  }

  /**
   * The harness, model and effort this user's sessions start on when a create names none.
   */
  async show(config?: AxiosRequestConfig): Promise<HarnessPreferences> {
    const orgId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.get<HarnessPreferencesResponse>(
      route(ENDPOINTS.HARNESS_PREFERENCES.SHOW, {
        organization_id: orgId || "",
        user_id: userId || "",
      }),
      config,
    );

    return response.data.data;
  }

  /**
   * Patch the preferences. Browser sessions may; sandbox and MCP tokens are refused.
   */
  async update(
    data: UpdateHarnessPreferencesRequest,
    config?: AxiosRequestConfig,
  ): Promise<HarnessPreferences> {
    const orgId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.patch<HarnessPreferencesResponse>(
      route(ENDPOINTS.HARNESS_PREFERENCES.UPDATE, {
        organization_id: orgId || "",
        user_id: userId || "",
      }),
      data,
      config,
    );

    return response.data.data;
  }
}
